<div *ngIf="this.menu != undefined && this.status;">
    <mat-toolbar style="max-height: 35px; background-color: white; padding-left: 5px">
        <a [routerLink]="['analytics']">
            <img src="../../../assets/logo.webp" style="width: 30px; margin-right: 5px" />
        </a>
        <a class="logoutButton" [routerLink]="[]" (click)="logout()">
            <mat-icon class="logout">logout</mat-icon>
        </a>
    </mat-toolbar>
    <mat-sidenav-container class="nav-container">
        <mat-sidenav [disableClose]="true" #sidenav mode="side" opened>
            <div *ngFor="let ele of menu; let i = index">
                <p class="menu" [matTooltip]="ele.name" matTooltipPosition="after">
                    <a *ngIf="ele.submenus.length == 0; else submenu" routerLink={{ele.pageID}}>
                        <button id={{ele.pageID}} [routerLinkActive]="['active']" mat-button>
                            <mat-icon>{{ele.icon}}</mat-icon>
                        </button>
                    </a>
                    <ng-template #submenu>
                        <button class="subMenuButton menu" [ngClass]="{'active' : checkActive(ele.pageID)}"
                            [matTooltip]="ele.name" matTooltipPosition="after" id={{ele.pageID}}
                            [matMenuTriggerFor]='subMenu'> <mat-icon>{{ele.icon}}</mat-icon>
                        </button>
                        <mat-menu #subMenu="matMenu">
                            <ng-container *ngFor="let e of ele.submenus">
                                <a class="subMenu" mat-menu-item *ngIf="e.submenus.length == 0" id={{e.pageID}}
                                    routerLink={{e.page}} [routerLinkActive]="['active']">
                                    <mat-icon>{{e.icon}}</mat-icon> {{e.name}}
                                </a>
                            </ng-container>
                        </mat-menu>
                    </ng-template>
                </p>
            </div>
        </mat-sidenav>
        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
<!-- Commenting template of loader since using lottie -->
<!-- <ng-template #loading>
    <div class="center loading">
        <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
    </div>
</ng-template> -->